import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const API_URL = "https://fsys.app.br/5dx/vendas.php";

// Função para construir a URL correta com as datas
const getApiUrl = (dataInicial, dataFinal) => {
  return `${API_URL}?dataInicial=${dataInicial}&dataFinal=${dataFinal}`;
};

// Componente de Card
const Card = ({ title, value, subtitle, color }) => (
  <div className="border rounded-lg shadow-md p-3 text-center position-relative bg-white w-100">
    <div
      className={`position-absolute top-0 start-50 translate-middle-x w-75 rounded-pill ${color}`}
      style={{ height: "8px" }}
    ></div>
    <h6 className="mt-3 text-muted">{title}</h6>
    <h2 className="fw-bold my-2">{value}</h2>
    <p className="text-muted small">{subtitle}</p>
  </div>
);

const fetchSalesData = async (setData, setLoading) => {
  try {
    setLoading(true);

    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const lastYearFirstDay = new Date(firstDay);
    lastYearFirstDay.setFullYear(lastYearFirstDay.getFullYear() - 1);
    const lastYearLastDay = new Date(lastDay);
    lastYearLastDay.setFullYear(lastYearLastDay.getFullYear() - 1);
    const lastYearYesterday = new Date(yesterday);
    lastYearYesterday.setFullYear(lastYearYesterday.getFullYear() - 1);

    const formatDate = (date) => date.toISOString().split("T")[0];

    console.log("Buscando venda D-1...");
    const vendaD1Res = await fetch(getApiUrl(formatDate(yesterday), formatDate(yesterday)));
    const vendaD1 = await vendaD1Res.json();

    console.log("Buscando venda D-1 ano passado...");
    const vendaD1LYRes = await fetch(getApiUrl(formatDate(lastYearYesterday), formatDate(lastYearYesterday)));
    const vendaD1LY = await vendaD1LYRes.json();

    console.log("Buscando venda MTD...");
    const vendaMTDRes = await fetch(getApiUrl(formatDate(firstDay), formatDate(lastDay)));
    const vendaMTD = await vendaMTDRes.json();

    console.log("Buscando venda MTD ano passado...");
    const vendaMTDLYRes = await fetch(getApiUrl(formatDate(lastYearFirstDay), formatDate(lastYearLastDay)));
    const vendaMTDLY = await vendaMTDLYRes.json();

    const calcularVariacao = (atual, passado) => {
      if (passado === 0) return "N/A";
      return `${(((atual - passado) / passado) * 100).toFixed(2)}%`;
    };

    setData({
      vendaD1: vendaD1.vendaTotal.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
      vendaMTD: vendaMTD.vendaTotal.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
      cupomMTD: vendaMTD.cupons.toLocaleString("pt-BR"),
      ticketMedioMTD: vendaMTD.ticketMedio.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
      uvcMTD: vendaMTD.totalProdutos > 0 ? (vendaMTD.totalProdutos / vendaMTD.cupons).toFixed(2) : "0",
      precoMedioMTD: vendaMTD.precoMedio.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
      comparisons: {
        vendaD1: calcularVariacao(vendaD1.vendaTotal, vendaD1LY.vendaTotal),
        vendaMTD: calcularVariacao(vendaMTD.vendaTotal, vendaMTDLY.vendaTotal),
      },
    });

  } catch (error) {
    console.error("Erro ao buscar os dados da API:", error);
  } finally {
    setLoading(false);
  }
};

const Dashboard = () => {
  const [data, setData] = useState({ comparisons: {} });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSalesData(setData, setLoading);
  }, []);

  const cards = [
    { title: "Venda D-1", value: data.vendaD1 || "R$ 0,00", subtitle: `% Last Year: ${data.comparisons?.vendaD1 || "N/A"}`, color: "bg-danger" },
    { title: "Venda MTD", value: data.vendaMTD || "R$ 0,00", subtitle: `% Last Year: ${data.comparisons?.vendaMTD || "N/A"}`, color: "bg-success" },
    { title: "Cupom MTD", value: data.cupomMTD || "0", subtitle: "% Last Year: N/A", color: "bg-warning" },
    { title: "Ticket Médio MTD", value: data.ticketMedioMTD || "R$ 0,00", subtitle: "% Last Year: N/A", color: "bg-info" },
    { title: "UVC MTD", value: data.uvcMTD || "0", subtitle: "% Last Year: N/A", color: "bg-danger" },
    { title: "Preço Médio MTD", value: data.precoMedioMTD || "R$ 0,00", subtitle: "% Last Year: N/A", color: "bg-dark" },
  ];

  return (
    <div className="container mt-4">
      <h3 className="text-center">Gestão a Vista</h3>

      {loading ? (
        <div className="text-center mt-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="mt-2">Carregando dados...</p>
        </div>
      ) : (
        <div className="row g-4">
          {cards.map((card, index) => (
            <div key={index} className="col-md-3 d-flex justify-content-center">
              <Card {...card} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dashboard;
